import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function contentReducer(state = initialState.content, action) {
  switch (action.type) {
    case types.LOAD_CONTENT_SUCCESS:
      return action.content;

    case types.CREATE_CONTENT_SUCCESS:
      return action.content;

    case types.UPDATE_CONTENT_SUCCESS:
      return action.content;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./library/app/reducers/contentReducer.js